import { createContext, useContext, useState } from 'react';
import { ErrorSystemModel } from '../../models/system/errorSystemModel';

interface SystemErrorContextType {
  systemError: ErrorSystemModel | null;
  triggerSystemError: (response: ErrorSystemModel) => void;
  clearSystemError: () => void;
}

const SystemErrorContext = createContext<SystemErrorContextType | undefined>(undefined);

export const useSystemError = () => {
  const context = useContext(SystemErrorContext);
  if (!context) {
    throw new Error('useSystemError must be used within a SystemErrorProvider');
  }
  return context;
};

export const SystemErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const [systemError, setSystemError] = useState<ErrorSystemModel | null>(null);

  const triggerSystemError = (response: ErrorSystemModel) => {
    setSystemError(response);
  };

  const clearSystemError = () => {
    setSystemError(null);
  };

  return (
    <SystemErrorContext.Provider value={{ systemError, triggerSystemError, clearSystemError }}>
      {children}
    </SystemErrorContext.Provider>
  );
};
